import React from 'react';
import MyBidsContainer from './myBids';
import Footer from '../../../navigation/footerContainer';

export default function MyBidsPage() {
    return(
        <>  
            <MyBidsContainer />
            <Footer />
        </>
    )
}